module.exports = __webpack_public_path__ + "components/flag/static/square/ne-f29c5545f88cb728e98200c768e25d32.svg";